import { render, staticRenderFns } from "./JobsOpportunities.vue?vue&type=template&id=aeabd3d4&scoped=true"
import script from "./JobsOpportunities.vue?vue&type=script&lang=js"
export * from "./JobsOpportunities.vue?vue&type=script&lang=js"
import style0 from "./JobsOpportunities.vue?vue&type=style&index=0&id=aeabd3d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeabd3d4",
  null
  
)

export default component.exports